export const ACADEMY_WELCOME_HELP_URL =
  'http://help.exploros.com/en/articles/16012368-exploros-academy';

export const ACADEMY_WELCOME_TEXT_BEFORE_LINK =
  'Welcome to Exploros Academy, an administrator and teacher self-paced training area.';

export const ACADEMY_WELCOME_LINK_TEXT = 'Learn More';

export const ACADEMY_WELCOME_TEXT_AFTER_LINK =
  'or get started with recommended next lessons.';

export const ACADEMY_WELCOME_ALERT_TEXT =
  `${ACADEMY_WELCOME_TEXT_BEFORE_LINK} ${ACADEMY_WELCOME_LINK_TEXT} ${ACADEMY_WELCOME_TEXT_AFTER_LINK}`;

export const ACADEMY_LOADING_MESSAGE = 'Loading Academy...';

export const ACADEMY_REQUEST_FAILED_MESSAGE = 'Academy request failed';

export const ACADEMY_NO_SKILLS_TITLE = 'Academy skills are not available';

export const ACADEMY_UNAVAILABLE_TITLE = 'Academy is not available';

export const ACADEMY_NO_SKILLS_WITH_PLAN_MESSAGE =
  'Academy access is active, but no skills are currently available for this user.';

export const ACADEMY_NO_ACTIVE_PLAN_MESSAGE =
  'No active plan with Academy access was found for this user.';

export const ACADEMY_AREA_MENU_ARIA_LABEL = 'Open Academy area menu';
